import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { selectCurrentToken } from '../app/authSlice';
import { useRefreshMutation } from '../app/api/console/consoleAuthApiSlice';

const ProtectedRoute = () => {
  const token = useSelector(selectCurrentToken);
  const location = useLocation();
  const [trueSuccess, setTrueSuccess] = useState(false);

  const [refresh, { isLoading, isSuccess, isError }] = useRefreshMutation();

  useEffect(() => {
    const verifyRefreshToken = async () => {
      try {
        console.log('Attempting to refresh token');
        await refresh().unwrap();
        setTrueSuccess(true);
      } catch (err) {
        console.error('Refresh failed:', err);
        // Silent failure - will redirect to login below
      }
    };

    // Only try to refresh if we don't have a token
    if (!token) {
      // Check if user was authenticated before (from localStorage)
      const storedAuth = localStorage.getItem('isAuthenticated');
      if (storedAuth === 'true') {
        verifyRefreshToken();
      }
    }
  }, [refresh, token]);

  let content;
  if (isLoading) {
    content = <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  } else if (isError) {
    // If refresh fails, redirect to login
    content = <Navigate to="/login" state={{ from: location }} replace />;
  } else if (isSuccess && trueSuccess) {
    // Successfully refreshed token
    content = <Outlet />;
  } else if (token) {
    // Already have a token, no need to refresh
    content = <Outlet />;
  } else {
    // No token and not trying to refresh, redirect to login
    content = <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  return content;
};

export default ProtectedRoute; 